__turbopack_context__.v({
  "buttonClear": "basket-clear-button-module-scss-module__Pt8nfq__buttonClear",
  "modalContent": "basket-clear-button-module-scss-module__Pt8nfq__modalContent",
});
